// extracted by mini-css-extract-plugin
module.exports = {"stickyCorner":"y49o7q","close":"M8cBnS","stickyCornerRight":"WkxH27","stickyCornerLeft":"ycN51s","placement":"_1_RqdR"};